import React, { Component } from "react";

export default class Dot extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			x: 0,
			y: 0
		};
	}

	logMousePosition = e => {
		this.setState({
			x: e.clientX,
			y: e.clientY
		});
	};
	componentDidMount() {
    	window.addEventListener("mousemove", this.logMousePosition);
    }
	render() {
		return (
			<div className="c-dot" style={{ left: this.state.x + 'px', top: this.state.y + 'px' }}>
				<div className="c-dot__logo">
					<svg x="0px" y="0px" viewBox="0 0 27 24"><path d="M23.79,4.78c-1.73-2.01-4.12-3.53-6.75-4.27C17.02,0.5,17,0.52,16.99,0.54 c-0.01,0.02,0,0.04,0.03,0.05c4.31,1.5,7.41,5.18,8.07,9.59l0.04-0.01l-0.04,0.02c0.03,0.17,0.05,0.35,0.07,0.53l0.01,0.1 c0.01,0.15,0.03,0.3,0.03,0.46l0,0.05c0,0.03,0,0.05,0,0.08c0.01,0.21,0.01,0.4,0.01,0.58c0,2.45-0.74,4.81-2.14,6.81 c-1.21,1.73-2.83,3.09-4.72,3.98c0,0,3.11-1.63,3.48-5c0-0.01,0-0.03,0-0.04c0,0,0-0.01,0-0.01l0,0c0.02-0.21,0.04-0.42,0.04-0.64 c0-1.19-0.2-2.21-0.58-3c-0.39-0.8-0.91-1.48-1.55-2.02c-0.03-0.03-0.06-0.05-0.09-0.07l-0.04-0.03c-0.61-0.51-1.31-0.93-2.14-1.28 c-0.16-0.07-0.5-0.21-0.5-0.21c-0.74-0.29-3.76-1.29-3.79-1.3c-0.38-0.12-0.77-0.24-1.14-0.36c-0.85-0.26-1.61-0.58-2.27-0.94 c-0.66-0.36-1.19-0.8-1.6-1.3c-0.4-0.5-0.6-1.14-0.6-1.9c0-2,1.69-3.14,1.71-3.16c0,0,0.15-0.12,0.42-0.29 c1.75-1.02,3.34-1.14,3.36-1.14c0,0,0,0,0,0c0,0,0.01,0,0.01,0c0.02,0,0.04-0.02,0.04-0.04C13.14,0.02,13.12,0,13.1,0 C9.67,0.05,6.41,1.32,3.92,3.58C1.39,5.86,0,8.85,0,12c0,2.82,1.16,5.59,3.28,7.78c2.06,2.13,4.84,3.57,7.84,4.05 c0.02,0,0.04-0.01,0.05-0.03c0-0.02-0.01-0.04-0.03-0.05c-0.23-0.05-0.43-0.1-0.62-0.16l-0.06-0.02C5.11,22.26,1.39,17.5,1.39,12 c0-2.73,0.9-5.3,2.59-7.42c1.44-1.8,3.38-3.16,5.54-3.88c0,0-2.78,1.07-3.93,3.71h0C5.22,5.2,5.03,6.04,5.03,6.9 c0,1.19,0.2,2.21,0.58,3c0.15,0.3,0.31,0.58,0.49,0.85c0.3,0.43,0.65,0.82,1.05,1.16c0.03,0.03,0.06,0.05,0.09,0.07l0.04,0.03 c0.61,0.51,1.31,0.93,2.14,1.28c0.16,0.07,0.5,0.21,0.5,0.21c0.74,0.29,3.75,1.29,3.79,1.3c0.39,0.12,0.77,0.24,1.14,0.36 c0.85,0.26,1.61,0.58,2.26,0.94c0.66,0.36,1.19,0.8,1.6,1.3c0.05,0.06,0.1,0.13,0.14,0.19c0.31,0.47,0.47,1.05,0.47,1.72 c0,2-1.69,3.14-1.71,3.16c-0.17,0.12-0.34,0.23-0.53,0.34c-1.67,0.88-2.86,1.06-3.3,1.09l-0.05,0c-0.02,0-0.04,0-0.07,0l-0.05,0 c-0.02,0-0.04,0.02-0.04,0.04c0,0.02,0.02,0.04,0.04,0.04c0,0,0.02,0,0.06,0c0.02,0,0.05,0,0.07,0c0.02,0,0.04,0,0.06,0 c0.05,0,0.17-0.01,0.26-0.01c0.14-0.01,0.28-0.02,0.42-0.03l0.09-0.01c0,0,0.01,0,0.01,0c6.7-0.63,11.95-5.88,11.95-11.94 C26.57,9.4,25.61,6.9,23.79,4.78"/></svg>
				</div>
				<div className="c-dot__left">
					<svg x="0px" y="0px" viewBox="0 0 32 32">
						<polygon points="20.48,0.1 22.01,1.48 8.7,16.31 22,30.7 20.49,32.1 5.92,16.33 "/>
					</svg>
				</div>
				<div className="c-dot__right">
					<svg x="0px" y="0px" viewBox="0 0 32 32">
						<polygon points="11.45,32.1 9.92,30.72 23.22,15.89 9.93,1.5 11.44,0.1 26.01,15.87 "/>
					</svg>
				</div>
			</div>
		);
  	}
}